export default {"src":"/_next/static/media/LAC.42a4535f.svg","height":18,"width":18};